import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded'
import { Button } from './Button'
import { useMaintenanceBanner } from '../../hooks/useMaintenanceBanner'
import { getNlsString } from '../../nls/nlsRuntime'

type MaintenanceBannerViewProps = { message: string; onDismiss: () => void }

/** Presentational half: the owner's message exactly as typed, plus a labelled dismiss. */
export const MaintenanceBannerView = ({ message, onDismiss }: MaintenanceBannerViewProps) => (
  <div className="pointer-events-none fixed inset-x-0 top-2 z-[90] flex justify-center px-4">
    <div
      role="status"
      aria-live="polite"
      data-testid="maintenance-banner"
      className="pointer-events-auto flex max-w-xl items-center gap-3 rounded-xl border border-[color-mix(in_srgb,var(--accent)_40%,transparent)] bg-[color-mix(in_srgb,var(--surface-raised)_92%,transparent)] px-4 py-2.5 text-sm font-medium text-[var(--accent-strong)] shadow-[var(--shadow-pop)] backdrop-blur-xl"
    >
      <span className="grid h-5 w-5 shrink-0 place-items-center" aria-hidden="true">
        <ConstructionRoundedIcon fontSize="inherit" />
      </span>
      <span className="min-w-0 flex-1 break-words">{message}</span>
      <Button
        variant="tertiary"
        size="sm"
        icon={<CloseRoundedIcon fontSize="inherit" />}
        aria-label={getNlsString('NLSCommonMaintenanceBannerDismiss')}
        onClick={onDismiss}
      />
    </div>
  </div>
)

/** Mounted once in each signed-in app shell (web console, Member, Helper). */
export const MaintenanceBanner = () => {
  const { visible, message, dismiss } = useMaintenanceBanner()
  if (!visible) return null
  return <MaintenanceBannerView message={message} onDismiss={dismiss} />
}
